import apiSlice from './apiSlice';

export interface DashboardStats {
  totalCertificates: number;
  totalEvents: number;
  todaysCertificates: number;
  certificateTypes: Record<string, number>;
}

export interface RecentActivityItem {
  id: string;
  title: string;
  date: string;
  organization: string;
  type?: string;
  description: string;
}

export interface Pagination {
  total: number;
  page: number;
  limit: number;
  pages: number;
}

export interface RecentActivity {
  data: RecentActivityItem[];
  pagination: Pagination;
}

export interface DashboardResponse {
  stats: DashboardStats;
  recentActivity: RecentActivity;
}

export const dashboardApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDashboard: builder.query<DashboardResponse, void>({
      query: () => ({
        url: '/dashboard',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetDashboardQuery } = dashboardApi;
